import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
    GET_MEMBER_INFO,
} from './actionTypes';


import {
	setMemberInfo
} from "./actions";

import MemberService from '../../services/HumanResources/MemberService';


export function* getMemberInfo () {
	yield takeEvery(GET_MEMBER_INFO, function* ({ payload: { token, history} }) {
		  try {
			  const response = yield call(MemberService.getCurrentAnetarData, token);
			  const profileData = response.data;

              localStorage.setItem("userData", JSON.stringify(profileData));
              yield put(setMemberInfo(profileData));

		  } catch (err) {

		  }
	  });
}


export default function* rootSaga() {
    yield all([
          fork(getMemberInfo),
    ]);
  }